export enum VehicleAutoCompleteTypeEnum {
	Partial = 1,
	Full = 2,
}
